import React, { Component } from "react";
import HomePage from "./pages/home";
import About from "./pages/aboutUs";
import RecentProjects from "./pages/project";
import Qualification from "./pages/qualification";
import ContactMe from "./pages/contact";
import AppBar from "./components/appBar";
import Particles from "react-tsparticles";
import Footer from "./pages/footer";

class App extends Component {
  state = {};
  particlesInit = (main) => {
    console.log(main);

    // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
  };

  particlesLoaded = (container) => {
    console.log(container);
  };

  render() {
    return (
      <main>
        <AppBar></AppBar>
        <HomePage />
        <About />
        <RecentProjects />
        <Qualification />
        <ContactMe />
        <Footer />
        <Particles
          className="particle-component"
          id="tsparticles"
          init={this.particlesInit}
          loaded={this.particlesLoaded}
          options={{
            fpsLimit: 60,
            fullScreen: { enable: true },
            particles: {
              number: {
                value: 50,
              },
              shape: {
                type: "circle",
              },
              opacity: {
                value: 0.2,
              },
              size: {
                value: 400,
                random: {
                  enable: true,
                  minimumValue: 200,
                },
              },
              move: {
                enable: true,
                speed: 15,
                direction: "top",
                outModes: {
                  default: "out",
                  top: "destroy",
                  bottom: "none",
                },
              },
            },
            interactivity: {
              detectsOn: "canvas",
              events: {
                resize: true,
              },
            },
            style: {
              filter: "blur(50px)",
            },
            detectRetina: true,
            themes: [
              // {
              //   name: "light",
              //   default: {
              //     value: true,
              //     mode: "light",
              //   },
              //   options: {
              //     background: {
              //       color: "#f7f8ef",
              //     },
              //     particles: {
              //       color: {
              //         value: [
              //           "#5bc0eb",
              //           "#fde74c",
              //           "#9bc53d",
              //           "#e55934",
              //           "#fa7921",
              //         ],
              //       },
              //     },
              //   },
              // },
              {
                name: "dark",
                default: {
                  value: true,
                  mode: "dark",
                },
                options: {
                  background: {
                    color: "#fff",
                  },
                  particles: {
                    color: {
                      value: [
                        // "#FFF1E6",
                        // "#FDE2E4",
                        // "#F0EFEB",
                        // "#DFE7FD",
                        // "#BEE1E6",
                        "#f2f4f9",
                      ],
                    },
                  },
                },
              },
            ],
            emitters: {
              direction: "top",
              position: {
                x: 50,
                y: 150,
              },
              rate: {
                delay: 0.2,
                quantity: 2,
              },
              size: {
                width: 100,
                height: 0,
              },
            },
          }}
        />
      </main>
    );
  }
}

export default App;
